module.exports = __webpack_public_path__ + "img/card-logos_legacy.a40812c4.png";